import React from "react";
import Sidebar from "../Sidebar/Sidebar";
import NavBar from "../NavBar/NavBar";
import "./Layout.css"
const Layout = ({ children }) => {
  return (
    <div className="layout">
      <Sidebar />
      <div className="layout_center">
      <div className="layout_center_container">
      <NavBar />
        {children}
      </div>
      </div>
    </div>
  );
};

export default Layout;
